export default {"src":"/_next/static/media/AboutUs_OurMission.9ecd9256.svg","height":338,"width":480,"blurWidth":0,"blurHeight":0};